import type { ProductDeliveryState, SelectionState } from './chatOrderReducer';
import { DEFAULT_DELIVERY_STATE, isOrderItemExist } from './chatOrderReducer';

export const isOrderItemSelected = (state: SelectionState, productId: string, optionId: string | null) =>
  state.orderItems.some((item) => isOrderItemExist(item, productId, optionId));

export const getSelectedItemQuantity = (state: SelectionState, productId: string, optionId: string | null) =>
  state.orderItems.find((item) => isOrderItemExist(item, productId, optionId))?.quantity ?? 0;

export const getProductDeliveryState = (state: SelectionState, productId: string): ProductDeliveryState =>
  state.deliveryByProduct[productId] ?? DEFAULT_DELIVERY_STATE;

export const isProductSelected = (state: SelectionState, productId: string) =>
  state.orderItems.some((item) => item.productId === productId);

export const isSubmitDisabled = (state: SelectionState) => state.orderItems.length === 0;

export const getItemsSubtotal = (state: SelectionState) =>
  state.orderItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

export const getDeliveryFeeCount = (state: SelectionState) =>
  Object.values(state.deliveryByProduct).filter((d) => d.includeDeliveryFee).length;
